import React from "react";
import { Link } from "react-router-dom";
import aqtLogo from "../../assets/images/aqtlogo.png";

const S = {
  footer: {
    background: "#0F2D6B", color: "rgba(255,255,255,0.35)",
    padding: "56px 6% 28px", fontFamily: "'DM Sans', sans-serif",
  },
  top: {
    display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr",
    gap: 40, marginBottom: 48,
  },
  brand: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 22,
    fontWeight: 600, color: "white", marginBottom: 4,
  },
  tagline: {
    fontSize: 11, color: "rgba(255,255,255,0.2)", letterSpacing: "0.1em",
    textTransform: "uppercase", marginBottom: 16,
  },
  contactInfo: { fontSize: 13, color: "rgba(255,255,255,0.35)", lineHeight: 1.8 },
  colHead: {
    fontSize: 10, fontWeight: 500, color: "rgba(255,255,255,0.35)",
    letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 14,
  },
  colLink: {
    display: "block", fontSize: 12, color: "rgba(255,255,255,0.3)",
    textDecoration: "none", marginBottom: 8, transition: "color 0.2s",
  },
  bottom: {
    borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: 20,
    display: "flex", flexDirection: "column", gap: 10,
  },
  bottomRow: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", flexWrap: "wrap", gap: 12,
  },
  copyright: { fontSize: 11, color: "rgba(255,255,255,0.2)" },
  legalLinks: { display: "flex", gap: 20, flexWrap: "wrap" },
  legalLink: {
    fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase",
    color: "rgba(255,255,255,0.2)", textDecoration: "none",
  },
  disclaimer: {
    fontSize: 11, color: "rgba(255,255,255,0.15)", lineHeight: 1.6, maxWidth: 680,
  },
};

function ColLink({ to, href, children }) {
  const hover = (e) => { e.currentTarget.style.color = "#2DD4A0"; };
  const leave = (e) => { e.currentTarget.style.color = "rgba(255,255,255,0.3)"; };
  if (to) return <Link to={to} style={S.colLink} onMouseEnter={hover} onMouseLeave={leave}>{children}</Link>;
  return <a href={href || "#"} style={S.colLink} onMouseEnter={hover} onMouseLeave={leave}>{children}</a>;
}

export default function Footer() {
  return (
    <footer style={S.footer}>
      <div className="aqt-footer-top" style={S.top}>
        {/* Brand */}
        <div>
          <img src={aqtLogo} alt="AQT Direct Limited" style={{ height: 44, width: "auto", marginBottom: 12, display: "block", filter: "brightness(0) invert(1)" }} />
          <div style={S.tagline}>Strategic Advisory · Capital · Growth</div>
          <div style={S.contactInfo}>
            <div>+91 70429 48655</div>
            <div><a href="mailto:support@aqtdirect.com" style={{ color: "#2DD4A0", textDecoration: "none" }}>support@aqtdirect.com</a></div>
            <div>311, Sector 19, NMS Icon</div>
            <div>Navi Mumbai, Ulwe, Panvel</div>
            <div>Maharashtra – 410206, India</div>
          </div>
        </div>

        {/* Advisory */}
        <div>
          <h5 style={S.colHead}>Advisory</h5>
          <ColLink to="/businesses">Strategic Advisory</ColLink>
          <ColLink to="/businesses">Capital Introductions</ColLink>
          <ColLink to="/afo">AQT Financial Officer</ColLink>
          <ColLink to="/businesses">Expansion Strategy</ColLink>
          <ColLink to="/businesses">Special Situations</ColLink>
        </div>

        {/* Company — old AQTLanding nav links */}
        <div>
          <h5 style={S.colHead}>Company</h5>
          <ColLink to="/about">About</ColLink>
          <ColLink to="/sectors">Sectors</ColLink>
          <ColLink to="/insights">Insights</ColLink>
          <ColLink to="/blogs">Blogs</ColLink>
          <ColLink to="/partners">Partners</ColLink>
          <ColLink to="/investors">Investors</ColLink>
          <ColLink to="/angel-investor">Angel Investor</ColLink>
          <ColLink to="/roadmap">Roadmap</ColLink>
          {/* <ColLink to="/partner-program">Partner Program</ColLink> */}
        </div>

        {/* Contact */}
        <div>
          <h5 style={S.colHead}>Contact</h5>
          <ColLink href="https://api.whatsapp.com/send?phone=919667773258">WhatsApp</ColLink>
          <ColLink href="mailto:info@aqtdirect.com">Email</ColLink>
          <ColLink to="/contactus">Request Discussion</ColLink>
          <ColLink to="/partner-program">Become a Partner</ColLink>
          <ColLink to="/privacy">Legal &amp; Policies</ColLink>
        </div>
      </div>

      <div style={S.bottom}>
        <div style={S.bottomRow}>
          <span style={S.copyright}>© 2025 AQT Direct Limited. All rights reserved.</span>
          <div style={S.legalLinks}>
            {[["Privacy Policy", "/legal"], ["Terms of Use", "/legal"], ["Refund Policy", "/legal"]].map(([label, to]) => (
              <Link key={label} to={to} style={S.legalLink}
                onMouseEnter={e => { e.currentTarget.style.color = "#2DD4A0"; }}
                onMouseLeave={e => { e.currentTarget.style.color = "rgba(255,255,255,0.2)"; }}
              >{label}</Link>
            ))}
          </div>
        </div>
        <p style={S.disclaimer}>
          AQT Direct Limited provides strategic advisory, business consulting, and investor-connect services. We do not provide securities brokerage, portfolio management, or regulated investment advisory services.
        </p>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .aqt-footer-top { grid-template-columns: 2fr 1fr 1fr !important; gap: 28px !important; }
        }
        @media (max-width: 768px) {
          .aqt-footer-top { grid-template-columns: 1fr 1fr !important; gap: 28px !important; }
        }
        @media (max-width: 480px) {
          .aqt-footer-top { grid-template-columns: 1fr !important; gap: 24px !important; }
        }
      `}</style>
    </footer>
  );
}
